// extracted by mini-css-extract-plugin
export default {"inputsContainer":"SearchInputs_inputsContainer__LMDMu","searchInput":"SearchInputs_searchInput__hvAv8"};